<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="agpm.plural"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <div class="flex gap-4 justify-end mb-5"></div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data || []" [totalRecords]="totalRecords" [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-dialog #dialog [dialog]="agpmDialog"></sm-dialog>
</div>
